import {Component, TemplateRef} from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'schedule-action-modal',
  templateUrl: './schedule-action.component.html'
})
export class ScheduleActionModal {

  constructor(public modalRef: BsModalRef) {}

  selected: string;
  public actions:Array<string> = [
    'Shortlist Colleges',
    'Application Material Sent',
    'Welcome Call',
    'Any Other Action'
  ];

}